<template>
  <div class="home">
    <HeaderBar :title="title"></HeaderBar>
    <div class="center-box">
    </div>
    <!-- <FooterBar></FooterBar> -->
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      title: '主页',

      //获得权限菜单接口
      urlRoleMenuList: this.$utils.Url.system + "/api/APISEMP_RoleMenu/RoleMenuList",
    }
  },
  computed: {},
  methods: {
    // 获得当前用的的菜单列表
    initRoleMenu: function () {
      let that = this;

      var args = {
        roleid: that.userModel.userExtension7
      }
      that.$utils.HttpPost(
        that.urlRoleMenuList, args,
        function (data) {
          // 获得所有菜单
          let dataList = data.data
          // 获得所有菜单的guid
          let guidList = dataList.map(m => m.guid)
          // 从底部菜单数组中,根据menuId,过滤出对应的底部菜单数组
          let roleMenuList = that.$utils.MenuBarList.filter(m => guidList.indexOf(m.menuId) != -1)
          // 过滤数组有值,默认跳转第一个
          if (roleMenuList.length > 0) {
            let menuUrl = roleMenuList[0].toUrl
            //新增设置vuex,将当前用户菜单写入全局变量中
            that.$store.commit("setRoleMenuList", roleMenuList)
            that.$router.push(menuUrl)

          } else {
            that.$dialog({ message: "当前用户未配置菜单,请联系管理员" })
          }

        }, null, null, null);
    },
  },
  mounted() {
    this.initRoleMenu()
    // this.$router.push({
    //   name:"s400PatientList"
    // })
  }
}
</script>

<style scoped="scoped"></style>
